import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Divider = () => (
  <div
    style={{
      borderTop: '1px solid #e2e2dd',
      margin: '0',
    }}
  />
);

export default function TermsAndConditions() {
  document.title = 'Nagra Accounting | Terms & Conditions';
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState<any>(null);

  const sections = [
    {
      id: 1,
      title: 'Acceptance of Terms',
      paragraphs: [
        'These Terms and Conditions Terms govern your engagement with Nagra Accounting and the use of our tax filing and financial services. By engaging our services or providing your information, you agree to be bound by these Terms.',
      ],
    },
    {
      id: 2,
      title: 'Description of Services',
      paragraphs: [
        'Nagra Accounting provides professional tax filing and related financial services to individuals and businesses. Services are delivered online, with client communication conducted primarily via WhatsApp and supplemented by automated transactional emails.',
        'Our specific services include, but are not limited to:',
      ],
      list: [
        'Personal and business tax return preparation and filing.',
        'Financial document review and processing.',
        'Digital document upload, review, and signature management.',
        'Status notifications and processing updates throughout the tax filing process.',
      ],
    },
    {
      id: 3,
      title: 'Client Responsibilities',
      paragraphs: ['By using our services, you agree to:'],
      list: [
        'Provide accurate, complete, and up-to-date information required for tax filing.',
        'Submit all requested documents in a timely manner.',
        'Review and respond promptly to notifications regarding documents requiring your signature.',
        'Provide a valid email address for receipt of transactional service notifications.',
        'Notify us immediately of any errors or changes in your submitted information.',
      ],
    },
    {
      id: 4,
      title: 'Email Communications',
      paragraphs: [
        'By providing your email address and engaging our services, you consent to receiving transactional emails from Nagra Accounting. These emails are strictly operational and will only be sent in direct connection with services you have requested.',
        'Types of transactional emails we send:',
      ],
      list: [
        'Payment confirmation.',
        'Confirmation that your tax filing has been completed.',
        'Notifications when documents are ready for review or signature.',
        'Status updates related to your tax processing.',
      ],
    },
    {
      id: 5,
      title: 'Email Opt-Out',
      paragraphs: [
        'Since all emails we send are transactional and directly tied to your service requests, they are necessary for service delivery. If you wish to stop receiving email communications, you may do so by notifying us in writing. Please note that opting out of emails may limit our ability to provide timely service updates.',
      ],
    },
    {
      id: 6,
      title: 'Fees and Payment',
      paragraphs: [
        'Service fees will be communicated to you prior to commencement of work. Fees are due as agreed upon during your engagement. A payment confirmation email will be sent automatically upon receipt of your payment.',
        'We reserve the right to withhold completed filings or documents until payment has been received in full.',
      ],
    },
    {
      id: 7,
      title: 'Confidentiality',
      paragraphs: [
        'We treat all client financial and personal information as strictly confidential. We will not disclose your information to any third party except as required by law, with your explicit consent, or as necessary to deliver our services (e.g., tax authorities, internal platforms).',
      ],
    },
    {
      id: 8,
      title: 'Accuracy of Information',
      paragraphs: [
        'Nagra Accounting relies entirely on the information you provide. We are not liable for errors, penalties, or consequences arising from inaccurate, incomplete, or misleading information provided by you. It is your responsibility to review all documents before signing and submission.',
      ],
    },
    {
      id: 9,
      title: 'Intellectual Property',
      paragraphs: [
        'All processes, templates, and systems used by Nagra Accounting remain our exclusive property. Prepared tax documents belong to you once payment has been received in full.',
      ],
    },
    {
      id: 10,
      title: 'Limitation of Liability',
      paragraphs: [
        "Nagra Accounting's liability is limited to the fees paid for the specific service in question. We are not liable for indirect, incidental, or consequential damages arising from errors based on client-provided information, delays caused by third-party systems, or circumstances beyond our reasonable control.",
      ],
    },
    {
      id: 11,
      title: 'Termination',
      paragraphs: [
        'Either party may terminate the service engagement at any time with written notice. Upon termination, you will be responsible for fees for work completed up to the termination date. We will return or provide access to your documents upon settlement of outstanding fees.',
      ],
    },
    {
      id: 12,
      title: 'Governing Law',
      paragraphs: [
        'These Terms shall be governed by and construed in accordance with applicable laws. Any disputes arising out of these Terms will be resolved through good-faith negotiation, and if necessary, through appropriate legal channels.',
      ],
    },
    {
      id: 13,
      title: 'Changes to These Terms',
      paragraphs: [
        'We reserve the right to modify these Terms at any time. Updated Terms will be posted on our website with a revised effective date. Continued use of our services constitutes acceptance of the revised Terms.',
      ],
    },
    {
      id: 14,
      title: 'Contact Us',
      paragraphs: [],
      contact: true,
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Georgia', 'Times New Roman', serif",
        backgroundColor: '#fafaf8',
        minHeight: '100vh',
        color: '#1a1a18',
      }}
    >
      {/* ── HERO ── */}
      <section
        style={{
          backgroundColor: '#1a1a18',
          color: '#fafaf8',
          padding: '68px 32px 60px',
        }}
      >
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h1
            style={{
              fontSize: 'clamp(30px, 4.5vw, 50px)',
              fontWeight: 'normal',
              letterSpacing: '-0.01em',
              textAlign: 'center',
              lineHeight: '1.15',
              marginBottom: '20px',
              fontFamily: 'Georgia, serif',
              margin: '0 0 20px 0',
            }}
          >
            Terms &amp; Conditions
          </h1>
          <p
            style={{
              fontSize: '15px',
              lineHeight: '1.7',
              color: '#9a9a92',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              fontFamily: 'Georgia, serif',
            }}
          >
            Please read these terms carefully before engaging with Nagra
            Accounting's tax filing and financial services.
          </p>
        </div>
      </section>

      {/* ── BODY ── */}
      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '0 32px',
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        {/* Sidebar */}
        <aside
          style={{
            width: '220px',
            flexShrink: 0,
            position: 'sticky',
            top: '88px',
            padding: '52px 36px 52px 0',
            borderRight: '1px solid #e2e2dd',
          }}
        >
          <p
            style={{
              fontSize: '10px',
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              color: '#aaa8a0',
              margin: '0 0 16px 0',
              fontFamily: 'Georgia, serif',
            }}
          >
            Contents
          </p>
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#section-${s.id}`}
              onClick={() => setActiveSection(s.id)}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                padding: '5px 0',
                fontSize: '12.5px',
                color: activeSection === s.id ? '#1a1a18' : '#888880',
                textDecoration: 'none',
                lineHeight: '1.45',
                fontFamily: 'Georgia, serif',
                borderLeft:
                  activeSection === s.id
                    ? '2px solid #1a1a18'
                    : '2px solid transparent',
                paddingLeft: activeSection === s.id ? '10px' : '0',
                marginLeft: activeSection === s.id ? '-12px' : '0',
                transition: 'color 0.15s',
              }}
              onMouseEnter={(e) => {
                if (activeSection !== s.id)
                  e.currentTarget.style.color = '#1a1a18';
              }}
              onMouseLeave={(e) => {
                if (activeSection !== s.id)
                  e.currentTarget.style.color = '#888880';
              }}
            >
              <span
                style={{
                  color: '#c8c8c0',
                  fontSize: '11px',
                  flexShrink: 0,
                  marginTop: '1px',
                }}
              >
                {String(s.id).padStart(2, '0')}
              </span>
              {s.title}
            </a>
          ))}
        </aside>

        {/* Main */}
        <main
          style={{
            flex: 1,
            paddingLeft: '56px',
            paddingTop: '52px',
            paddingBottom: '80px',
          }}
        >
          {sections.map((s, idx) => (
            <div key={s.id}>
              <div
                id={`section-${s.id}`}
                style={{ paddingTop: '8px', paddingBottom: '44px' }}
              >
                {/* Title row */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '16px',
                    marginBottom: '20px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '11px',
                      color: '#c0c0b8',
                      fontFamily: 'Georgia, serif',
                      letterSpacing: '0.08em',
                      flexShrink: 0,
                      minWidth: '22px',
                    }}
                  >
                    {String(s.id).padStart(2, '0')}
                  </span>
                  <h2
                    style={{
                      fontSize: '19px',
                      fontWeight: 'normal',
                      color: '#1a1a18',
                      fontFamily: 'Georgia, serif',
                      margin: 0,
                      letterSpacing: '-0.01em',
                    }}
                  >
                    {s.title}
                  </h2>
                </div>

                {/* Paragraphs */}
                {s.paragraphs &&
                  s.paragraphs.map((p, i) => (
                    <p
                      key={i}
                      style={{
                        fontSize: '15px',
                        lineHeight: '1.85',
                        color: '#3c3c38',
                        fontFamily: 'Georgia, serif',
                        marginBottom: '12px',
                        marginLeft: '38px',
                        marginTop: 0,
                      }}
                    >
                      {p}
                    </p>
                  ))}

                {/* List */}
                {s.list && (
                  <ul
                    style={{
                      marginLeft: '38px',
                      padding: 0,
                      listStyle: 'none',
                      marginTop: '10px',
                      marginBottom: '12px',
                    }}
                  >
                    {s.list.map((item, i) => (
                      <li
                        key={i}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '14px',
                          fontSize: '15px',
                          lineHeight: '1.8',
                          color: '#3c3c38',
                          fontFamily: 'Georgia, serif',
                          marginBottom: '6px',
                        }}
                      >
                        <span
                          style={{
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            backgroundColor: '#c0c0b8',
                            flexShrink: 0,
                            marginTop: '11px',
                          }}
                        />
                        {item}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Contact block */}
                {s.contact && (
                  <div style={{ marginLeft: '38px' }}>
                    <p
                      style={{
                        fontSize: '15px',
                        lineHeight: '1.85',
                        color: '#3c3c38',
                        fontFamily: 'Georgia, serif',
                        marginBottom: '24px',
                        marginTop: 0,
                      }}
                    >
                      For questions, concerns, or to exercise any rights under
                      these Terms, please reach out to us:
                    </p>
                    <div
                      style={{
                        display: 'inline-block',
                        border: '1px solid #e2e2dd',
                        padding: '24px 32px',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '10px',
                          letterSpacing: '0.15em',
                          textTransform: 'uppercase',
                          color: '#aaa8a0',
                          margin: '0 0 6px 0',
                          fontFamily: 'Georgia, serif',
                        }}
                      >
                        Email
                      </p>
                      <a
                        href="mailto:info@nagraaccounting.com"
                        style={{
                          fontSize: '15px',
                          color: '#1a1a18',
                          textDecoration: 'none',
                          fontFamily: 'Georgia, serif',
                          borderBottom: '1px solid #1a1a18',
                          paddingBottom: '1px',
                        }}
                      >
                        info@nagraaccounting.com
                      </a>
                    </div>
                  </div>
                )}
              </div>
              {idx < sections.length - 1 && <Divider />}
            </div>
          ))}
        </main>
      </div>

      {/* ── BOTTOM BAR ── */}
      <div
        style={{
          borderTop: '1px solid #e2e2dd',
          backgroundColor: '#ffffff',
          padding: '20px 32px',
        }}
      >
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontSize: '12px',
              color: '#aaa8a0',
              fontFamily: 'Georgia, serif',
              letterSpacing: '0.03em',
            }}
          >
            © 2026 Nagra Accounting. All rights reserved.
          </span>
        </div>
      </div>
    </div>
  );
}
